import React from "react"

import "moment/locale/es"

import PageBase from "components/Common/PageBase"
import FullSpinner from "components/Common/FullSpinner"

import useOrdersCreateV2 from "./useOrdersCreateV2"
import { BREADCRUMB_LIST, MODO_GRANJA, MODO_REGION } from "./static"
import OrderHeaderV2 from "./components/OrderHeaderV2"
import DayOrdersStrip from "./components/DayOrdersStrip"
import ComparatorToolbar from "./components/ComparatorToolbar"
import ComparatorTable from "./components/ComparatorTable"
import ConfirmBar from "./components/ConfirmBar"

import "./orders-create-v2.css"

const OrdersCreateV2Container = () => {
  const { state, events } = useOrdersCreateV2()

  const pestanas = [
    { value: MODO_REGION, label: "Reparto a región", count: state.countRegion },
    { value: MODO_GRANJA, label: "Entrega en granja", count: state.countGranja },
  ]

  return (
    <>
      {state.isLoading && <FullSpinner />}

      <PageBase
        titleMeta="Crear Pedidos v2"
        titleBread="Crear Pedidos v2"
        itemsBread={BREADCRUMB_LIST}
      >
        <div className="pv2-page">
          <div className="pv2-sticky">
            <div className="pv2-card pv2-anim">
              <OrderHeaderV2
                clients={state.clients}
                clientId={state.clientId}
                dates={state.dates}
                date={state.date}
                addresses={state.addresses}
                addressId={state.addressId}
                address={state.address}
                minutosCierre={state.minutosCierre}
                onChangeClient={events.onChangeClient}
                onChangeDate={events.onChangeDate}
                onChangeAddress={events.onChangeAddress}
              />
              {state.clientId && (
                <DayOrdersStrip
                  pedidos={state.pedidosDia}
                  abierto={state.diaAbierto}
                  isSaving={state.isSaving}
                  onToggle={events.onToggleDia}
                  onEliminar={events.onEliminarPartida}
                />
              )}
            </div>
          </div>

          {!state.clientId && !state.isLoading && (
            <div className="pv2-card pv2-empty">
              Selecciona un cliente para comparar la disponibilidad del día.
            </div>
          )}

          {state.sinOfertas && (
            <div className="pv2-card pv2-empty">
              No hay disponibilidad de proveedores para la fecha y la región de
              entrega seleccionadas.
            </div>
          )}

          {state.clientId && !state.sinOfertas && (
            <>
              <div className="pv2-tabs pv2-anim">
                {pestanas.map(pestana => (
                  <button
                    key={pestana.value}
                    type="button"
                    className={`pv2-tab${
                      state.modo === pestana.value ? " is-on" : ""
                    }`}
                    onClick={() => events.onChangeModo(pestana.value)}
                  >
                    {pestana.label}
                    <span className="pv2-tab-badge">{pestana.count}</span>
                  </button>
                ))}
              </div>

              <div className="pv2-card pv2-comparador pv2-anim">
                <ComparatorToolbar
                  productos={state.productos}
                  producto={state.producto}
                  orden={state.orden}
                  busqueda={state.busqueda}
                  visibles={state.filas.length}
                  total={state.totalPool}
                  onChangeProducto={events.onChangeProducto}
                  onChangeOrden={events.onChangeOrden}
                  onChangeBusqueda={events.onChangeBusqueda}
                />
                <ComparatorTable
                  filas={state.filas}
                  esLocal={state.esLocal}
                  fechasRecepcion={state.fechasRecepcion}
                  fechaPedido={state.date}
                  isSaving={state.isSaving}
                  onChangeCantidad={events.onChangeCantidad}
                  onChangeFecha={events.onChangeFecha}
                  onChangeHora={events.onChangeHora}
                  onAgregar={events.onAgregar}
                />
              </div>

              <ConfirmBar
                selCount={state.selCount}
                selPiezas={state.selPiezas}
                selImporte={state.selImporte}
                ahorro={state.ahorro}
                hayExcesos={state.hayExcesos}
                puedeSolicitar={state.puedeSolicitar}
                isSaving={state.isSaving}
                onLimpiar={events.onLimpiar}
                onSolicitar={events.onSolicitar}
              />
            </>
          )}
        </div>
      </PageBase>
    </>
  )
}

export default OrdersCreateV2Container
